var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{staticClass:"software-license",attrs:{"cpf":_vm.cpf},on:{"update:cpf":function($event){_vm.cpf=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }